<script lang="ts" module>
  import {
    Activations,
    Directions,
    Orientations,
    type Activation,
    type Direction,
    type Orientation,
  } from "#lib/internal/constants"
  import { reactiveContext, useActions } from "#lib/internal/helpers"
  import { cn } from "#lib/utils"
  import type { HTMLAttributes } from "svelte/elements"

  type TabsRootProps = HTMLAttributes<HTMLDivElement> & {
    value?: unknown
    activateOn?: Activation | undefined
    orientation?: Orientation | undefined
    dir?: Direction | undefined
    use?: any[]
  }

  const defaults: TabsRootProps = {
    value: void 0,
    activateOn: Activations.FOCUS,
    orientation: Orientations.HORIZONTAL,
    dir: Directions.LTR,
  }

  const { getContext, setContext } = reactiveContext(defaults)
  export const getTabsRootContext = getContext
</script>

<script lang="ts">
  import type { Snippet } from "svelte"

  type Props = TabsRootProps & {
    children?: Snippet
  }

  let {
    value = $bindable(defaults.value),
    dir = defaults.dir,
    orientation = defaults.orientation,
    activateOn = defaults.activateOn,
    class: className = "",
    use = [],
    children,
    ...restProps
  }: Props = $props()

  const ctx = setContext({
    value: (v: unknown) => {
      if (v !== value) value = v
    },
  })

  $effect(() => {
    ctx.update((old) => ({ ...old, value, activateOn, orientation, dir }))
  })
</script>

<div
  class={cn("w-full", className)}
  {dir}
  data-orientation={orientation}
  {...restProps}
  use:useActions={use}
>
  {@render children?.()}
</div>
